<!-- Header section -->
<login-header></login-header>

<div class="introducing_blade">
    <div class="intro_sec">
        <div class="video_head">
            <h2>Welcome to Family Central: Advisors</h2>
            <div class="border_btm"></div>
        </div>
        <div class="welcome_video_wrapper card_wrapper">
            <div class="welcome_video_content card_container">
                <div class="welcome_video ratio ratio-16x9">
                    <iframe src="https://player.vimeo.com/video/910873205?h=6096bd7bfa&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen title="Welcome, Trusted Professional Advisors">
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Footer section -->
<app-footer></app-footer>